import { SearchField } from "../../../../components/form-controls/search-field/search-field.component";
import { UsersSearchResults } from "../users-search-results/users-search-results.component";
import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import * as store from "../../store/users.store";
import { createUsersSearchForm } from "../../types/users-search-form.functions";
import { useSelector } from "react-redux";
import { UsersSearchProps } from "./users-search.props";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import { IUser } from "../../../../types/user/iuser.interface";
import { Nullable } from "../../../../types/common";

export const UsersSearch = withShowIf((props: UsersSearchProps) => {
  const { currentValue = [] } = props;

  const ref: MutableRefObject<Nullable<HTMLDivElement>> = useRef(null);
  const [shouldReset, setShouldReset] = useState(false);

  const searchResults = useSelector(store.getSearchResults) || [];
  const selectedIds = currentValue.map((user) => user.id);
  const filteredResults = searchResults.filter((user) => !selectedIds.includes(user.id));

  useEffect(
    () => {
      document.addEventListener("click", handlePageClick);
      return () => document.removeEventListener("click", handlePageClick);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    setShouldReset(props.reset || false);
  }, [props]);

  const handleSearch = (searchTerm: string) => {
    if (searchTerm.length) {
      store.searchUsers(
        createUsersSearchForm(searchTerm, props.resourceId, props.resourceType, props.groupFilter)
      );
    }
  };

  const reset = () => store.resetSearchResults();

  const onSelect = (user: IUser) => {
    props.onSelect(user);
    reset();
  };

  const handlePageClick = (e: any) => {
    if (ref.current && !ref.current?.contains(e.target)) {
      setShouldReset(true);
      reset();
    }
  };

  return (
    <div ref={ref}>
      <SearchField
        id={props.id}
        label={props.label || "search"}
        placeholder={props.placeholder || "Search"}
        size={props.size || "small"}
        isDisabled={props.isDisabled || false}
        ref={props.ref}
        resetSearch={shouldReset || Boolean(props.reset)}
        onSearch={handleSearch}
        onCancel={reset}
      />
      {props.children}
      <UsersSearchResults users={filteredResults} handleSelect={onSelect} />
    </div>
  );
});
